export const  theme = {
    breakpoints: {
        sm: '576px',
        md: '800px',
        lg: '1024px',
        xl: '1280px',
        xxl: '1440px',
    },
};